import React from 'react';
import NewToolForm from '../components/tools/NewToolForm';

export default function NewToolPage() {
  return (
    <div className="max-w-2xl mx-auto">
      <NewToolForm />
    </div>
  );
}